<template>
  <div>
    <div class="seachBox flex">
      <div class="seachList">
        <span class="name">客户名称：</span>
        <a-select
            placeholder="请输入客户名称"
            v-model="seach.a_customer_id"
            class="seachs"
            :default-active-first-option="false"
            :filter-option="false"
            :not-found-content="null"
            :show-arrow="false"
            show-search
            option-label-prop="label"
            @change="handleChange"
            @search="handleSearch"
        >
          <a-select-option
              v-for="item in options"
              :key="item.value"
              :value="item.value"
              :label="item.label"
          >
            <div class="flex">
              <span>{{ item.label  }}</span>
              <span style="color: #999; margin-left: 8px;">{{ item.erp_contract_number }}</span>
            </div>

          </a-select-option>
        </a-select>
      </div>
    </div>

    <a-alert
      :message="message"
      type="info"
      v-if="!message == '' && activeKey == '1'"
      style="margin-bottom: 10px;"
    />
  </div>
</template>

<script>
import moment from "moment";
import { debounce } from "@/utils/utils";
import API from "../api";
export default {
  name: "search",
  props: ["activeKey"],
  data() {
    return {
      seach: {
        a_customer_id: undefined
      },
      options: [],
      customerList: [],
      message: "",
    };
  },
  components: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {
    handleChange(value) {
      this.$emit("customerIdChange", value);
      if (value == undefined) return;
      this.customerList.forEach((item,index)=>{
        if(item.id==value)this.message=`该公司购买字符${item.translation_set_num}个剩余字符${item.translation_surplus_num}个`
      })
    },

    handleSearch: debounce(function (val) {
      this.handleSearchFn(val);
    }, 300),
    handleSearchFn(val) {
      this.options = [];
      //下拉模糊查询
      if (val) {
        this.getSeachList(val);
      }
    },

    getSeachList(company) {
      API.service.GET_NAME({ company }).then((res) => {
        this.customerList = res.data.data;
        res.data.data.forEach((item) => {
          this.options.push({
            value: item.id,
            erp_contract_number:item.erp_contract_number,
            label: item.company,
            name:item.erp_contract_number,
          });
        });
      });
    }
  }
};
</script>

<style scoped>
.seachList{width: 40vw!important;}
.seachBox .seachList .name {
  width: 70px !important;
}

.seachBox .seachList .seachs {
  width: calc(100% - 80px);
}
</style>
